import { createSlice } from '@reduxjs/toolkit';
import {
  CreateCategory,
  DeleteCategory,
  EditCategoryDetail,
  GetAllCategory,
  GetAllMajorCategory,
  GetSingleCategoryDetails,
  SearchForCategorysByName,
  UploadCategoryIcon,
  UploadCategoryImage,
} from './category_services_syn';

export const categorySlice = createSlice({
  name: 'category',
  initialState: {
    category_loader: false,
    allCategoryLoader: true,
    categoryDeleteLoader: false,
    categoryEditLoader: false,
    catEditLoader: false,
    message: '',
    completeCategory: {},
    completeMajorCategory: [],
    categoryDetails: {},
    categoryImageDetails: {},
    categoryIconDetails: {},
    completeCategorySearch: {},
    category_page: 0,
    category_limit: 10,
    editCategoryId: '',
  },
  reducers: {
    clearState: (state) => {
      state.category_loader = false;
      state.message = '';
      state.completeCategory = {};
      state.completeMajorCategory = [];
      state.allCategoryLoader = true;
      state.categoryDeleteLoader = false;
      state.categoryEditLoader = false;
      state.catEditLoader = false;
      state.categoryDetails = {};
      state.completeCategorySearch = {};
      state.categoryImageDetails = {};
      state.categoryIconDetails = {};
      state.editCategoryId = '';

      return state;
    },

    updateCategoryDetails: (state, action) => {
      state.categoryDetails = action.payload;
    },

    updateCompleteCategory: (state, action) => {
      state.completeCategory = action.payload;
    },
    updateCategoryId: (state, { payload }) => {
      state.editCategoryId = payload;
    },

    updateCategoryImageDetails: (state, { payload }) => {
      state.categoryImageDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateCategory.pending, (state) => {
        state.category_loader = true;
      })
      .addCase(CreateCategory.fulfilled, (state, { payload }) => {
        // let addCategory = {...payload?.data, six ...state?.completeCategory};

        // state.completeCategory = addCategory;

        state.category_loader = false;
        state.message = payload.message;
        state.categoryImageDetails = {};
      })
      .addCase(CreateCategory.rejected, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadCategoryImage.pending, (state) => {
        state.categoryEditLoader = true;
      })
      .addCase(UploadCategoryImage.fulfilled, (state, { payload }) => {
        state.categoryEditLoader = false;
        state.profileMessage = payload.message;
        state.categoryImageDetails = payload.data;
      })
      .addCase(UploadCategoryImage.rejected, (state, { payload }) => {
        state.categoryEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(UploadCategoryIcon.pending, (state) => {
        state.categoryEditLoader = true;
      })
      .addCase(UploadCategoryIcon.fulfilled, (state, { payload }) => {
        state.categoryEditLoader = false;
        state.profileMessage = payload.message;
        state.categoryIconDetails = payload.data;
      })
      .addCase(UploadCategoryIcon.rejected, (state, { payload }) => {
        state.categoryEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(GetAllCategory.pending, (state) => {
        state.category_loader = true;
      })
      .addCase(GetAllCategory.fulfilled, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
        state.completeCategory = payload.data;
        state.category_page = payload?.data?.page;
      })
      .addCase(GetAllCategory.rejected, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorCategory.pending, (state) => {
        state.category_loader = true;
      })
      .addCase(GetAllMajorCategory.fulfilled, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
        state.completeMajorCategory = payload.data;
      })
      .addCase(GetAllMajorCategory.rejected, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteCategory.pending, (state) => {
        state.categoryDeleteLoader = true;
      })
      .addCase(DeleteCategory.fulfilled, (state, { payload }) => {
        const filterData = state.completeCategory?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeCategory = {
          ...state.completeCategory,
          docs: filterData,
        };

        state.categoryDeleteLoader = false;
        state.message = payload.message;

        state.editCategoryId = '';
      })
      .addCase(DeleteCategory.rejected, (state, { payload }) => {
        state.categoryDeleteLoader = false;
        state.message = payload.message;
        state.editCategoryId = '';
      })
      .addCase(GetSingleCategoryDetails.pending, (state) => {
        state.category_loader = true;
      })
      .addCase(GetSingleCategoryDetails.fulfilled, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
        state.categoryDetails = payload.data;
      })
      .addCase(GetSingleCategoryDetails.rejected, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload.message;
      })
      .addCase(EditCategoryDetail.pending, (state) => {
        state.catEditLoader = true;
      })
      .addCase(EditCategoryDetail.fulfilled, (state, { payload }) => {
        // const findIndex = state.completeCategory?.findIndex(
        //   (item) => item?._id === payload?.data?._id
        // );

        // state.completeCategory?.splice(findIndex, 1, payload?.data);

        // state.completeCategory = state.completeCategory;

        state.catEditLoader = false;
        state.message = payload.message;

        state.categoryImageDetails = {};
      })
      .addCase(EditCategoryDetail.rejected, (state, { payload }) => {
        state.catEditLoader = false;
        state.message = payload.message;
      })

      .addCase(SearchForCategorysByName.pending, (state) => {
        state.category_loader = true;
      })
      .addCase(SearchForCategorysByName.fulfilled, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload?.message;

        state.completeCategorySearch = payload?.data;
      })
      .addCase(SearchForCategorysByName.rejected, (state, { payload }) => {
        state.category_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  updateCategoryDetails,
  updateCompleteCategory,
  updateCategoryId,
  updateCategoryImageDetails,
} = categorySlice.actions;
export const categroySelector = (state) => state.category;

export default categorySlice.reducer;
